module.exports = __webpack_public_path__ + "img/MapPicsCampLagoon.efbd6ede.webp";